// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1_Gx9","boxTitle":"Qualiphy_boxTitle__1aY-C","box":"Qualiphy_box__11F_I","toggleWrap":"Qualiphy_toggleWrap__2ImGR"};